export var win;
if (typeof (window) === 'undefined') {
  win = {
    navigator: {},
    console: {},
    location: {},
    document: {}
  };
} else {
  win = window;
}

export const windowNavigator = win.navigator;
export const windowConsole = win.console;
export const windowLocation = win.location;
export const windowDocument = win.document;



/** WEBPACK FOOTER **
 ** ./src/utils/window.js
 **/